<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/master/list') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/area_pref/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="typeof pref_list === 'object' && Object.keys(pref_list).length > 0"
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 10%">都道府県コード</th>
            <th style="width: 30%">名称</th>
            <th style="width: 30%">地域</th>
            <th style="width: 10%">ソートNo</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in pref_list" :key="list.id">
            <td>{{ list.pref_cd }}</td>
            <td>{{ list.label }}</td>
            <td>{{ list.region_label }}</td>
            <td>{{ list.sort }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/master/list')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'CategoryListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '都道府県マスタ一覧',
      fromParentBtn: 'データ登録',
      pref_obj: [],
      region_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    get_region_data: function () {
      const region_list = this.region_list
      return function (region_cd) {
        return region_list.find(region => region.region_cd == region_cd)
      }
    },
    get_region_label: function () {
      const get_func = this.get_region_data
      return function (region_cd) {
        if (get_func(region_cd)) {
          return get_func(region_cd).label
        }
        return ''
      }
    },
    pref_list: function () {
      const lists = [...this.pref_obj]
      return lists
        .map(list => {
          list.region_label = this.get_region_label(list.region_cd)
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    region_list: function () {
      const lists = [...this.region_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadRegionList()
    await this.loadPrefList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '都道府県マスタです。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.pref_obj.find(region => {
          return region.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'area_pref' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadPrefList()
          })
      }
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/area_pref/' + target + '/' })
    }
  }
}
</script>
